// Appointment API calls — same endpoints and params as the Android technician app
// (api/v3/pro/appointments/*). Every call resolves to { ok, body, message, activeRecord } and never throws;
// apiCall shows the global loader.
import { apiCall } from "./apiCall";

export const appointmentApi = {
  view: (id) => apiCall("post", "appointments/view", { id }),
  claim: (id) => apiCall("post", "appointments/claim", { id }),

  // cancel: reasons are plain strings; "Other" needs cancel_reason_other
  cancelReasons: (id) => apiCall("get", `appointments/cancel/reason/${id}`),
  cancel: (id, reason, otherReason) => apiCall("put", "appointments/cancel", {
    appointment_id: id,
    cancel_reason: reason,
    ...(otherReason ? { cancel_reason_other: otherReason } : {}),
  }),

  // disposition / resume (Android sends appointment_id to dispose-reasons; the API ignores it)
  disposeReasons: (id) => apiCall("get", "dispose-reasons", { appointment_id: id }),
  dispose: (id, reasonId, notes) => apiCall("put", "appointments/dispose", { appointment_id: id, reason_id: reasonId, dispose_notes: notes || "" }),
  resume: (id, notes) => apiCall("put", "appointments/resume", { appointment_id: id, resume_notes: notes }),

  // no-charge appointments
  close: (id) => apiCall("put", "appointments/close", { appointment_id: id }),
  noChargeNotes: (id, opts) => apiCall("get", "appointments/no-charge/get-notes", { appointment_id: id }, opts),
  addNoChargeNote: (id, notes) => apiCall("post", "appointments/no-charge", { appointment_id: id, notes }),

  // link an order made in the create-order web flow to this appointment
  convertToOrder: (id, orderId) => apiCall("put", "appointments/convert/order", { appointment_id: id, order_id: orderId }),

  // one active job at a time (Android passes appointment_id)
  singleActiveRecord: (id) => apiCall("get", "single-active-record", { appointment_id: id }),

  // documents (store is multipart: appointment_id, title, document, optional id to replace)
  documents: (id, opts) => apiCall("get", "appointments/documents", { appointment_id: id }, opts),
  uploadDocument: (id, file, title) => {
    const form = new FormData();
    form.append("appointment_id", id);
    form.append("document", file);
    if (title) form.append("title", title);
    return apiCall("post", "appointments/documents/store", form);
  },
  // axios.delete(url, config): send the ids as query params
  deleteDocument: (id, documentId) => apiCall("delete", "appointments/documents/delete", { params: { appointment_id: id, id: documentId } }),

  members: (consumerId) => apiCall("get", "consumer/member/list", { consumer_id: consumerId }),
};

// Appointment statuses (Laravel app/Models/V2/AppointmentStatus.php)
export const APPT_STATUS = {
  PENDING: 0, EN_ROUTE: 1, ARRIVED: 2, CONVERTED_BOOKING: 3, CONVERTED_ORDER: 4, NO_SALE: 5,
  CLOSED: 6, CANCELLED: 7, BAD_CREDIT: 8, DISPOSED: 10,
};
